<template>
  <transition name="modal">
    <div class="modal-mask" style="display: block">
      <div class="modal-dialog modal modal-special" role="document">
        <div class="modal__content modal__content--lg">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">
              <template v-if="!task_validated">Crear Tarea</template>
              <template v-else>Confirmar Tarea</template>
              <br />
              <AppTitleCustom />
            </h2>
          </div>
          <form
            @submit.prevent="createTask"
            enctype="multipart/form-data"
            class="form-task"
          >
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-12 sm:col-span-12">
                <label>Nombre</label>
                <input
                  type="text"
                  v-model="task.name"
                  required
                  :disabled="task_validated"
                  :class="`input w-full border mt-2 flex-1 ${
                    task_validated && 'border-theme-12'
                  }`"
                />
              </div>
              <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                <label>Descripcion</label>
                <textarea
                  class="input w-full border mt-2"
                  rows="3"
                  v-model="task.description"
                  :disabled="task_validated"
                  :class="{ 'border-theme-12': task_validated }"
                ></textarea>
              </div>
              <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                <div
                  class="rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
                >
                  <b>Nota:</b> Proporciona una descripción completa y clara de
                  lo que necesitas.
                </div>
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Fecha de entrega</label>
                <input
                  type="date"
                  class="input w-full border mt-2 flex-1"
                  v-model="task.date"
                  required
                  :disabled="task_validated"
                  :class="{ 'border-theme-12': task_validated }"
                />
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="task.project_id"
                  required
                  :disabled="task_validated"
                  :class="{ 'border-theme-12': task_validated }"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="project in filteredProjects"
                    :value="project.id"
                    :key="`create-task-project-${project.id}`"
                  >
                    {{ project.name }} - {{ project.account.prefix }}
                  </option>
                </select>
              </div>
              <div class="col-span-12 sm:col-span-12">
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="task.campaign_id"
                  required
                  :disabled="task_validated"
                  :class="{ 'border-theme-12': task_validated }"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="campaign in filteredCampaigns"
                    :value="campaign.id"
                    :key="`create-task-campaign-${campaign.id}`"
                  >
                    {{ campaign.name }} - {{ campaign.project.name }}
                  </option>
                </select>
              </div>

              <div class="col-span-12 sm:col-span-12">
                <label>Url Archivo (opcional)</label>
                <MultiSelect
                  v-model="task.path"
                  :options="options"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag"
                  class="mt-2"
                  :class="{ 'border-theme-12 border': task_validated }"
                  :disabled="task_validated"
                />
              </div>
              <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                <div
                  class="rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
                >
                  <b>Nota:</b> Recuerda compartir la carpeta o archivo a las
                  personas involucradas.
                </div>
              </div>

              <div
                class="col-span-12 sm:col-span-12"
                v-if="task_loading < 11 && 0 < task_loading"
              >
                <p class="text-theme-1 font-extrabold block">
                  El botón se activara en {{ task_loading }} segundos, mientras
                  verificas la información.
                </p>
              </div>
            </div>
            <div
              class="px-5 py-3 text-right border-t border-gray-200"
              v-show="!task_validated"
            >
              <button
                type="button"
                @click="$emit('closeModal')"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button type="submit" class="button bg-theme-1 text-white">
                Verificar Tarea
              </button>
            </div>
            <div
              class="px-5 py-3 text-right border-t border-gray-200"
              v-show="task_validated"
            >
              <a
                type="button"
                @click="task_validated = !task_validated"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </a>

              <button
                type="submit"
                class="button bg-theme-1 text-white"
                :disabled="taskButtonLoading"
              >
                <template v-if="taskButtonLoading">
                  Verificando Tarea...
                </template>
                <template v-else> Confirmar Tarea </template>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  props: ['task', 'options', 'team_session', 'defineQuery'],
  data() {
    return {
      task_loading: 11,
      task_validated: false,
      taskButtonLoading: false,
    }
  },
  components: {
    MultiSelect,
    AppTitleCustom: TitleCustom,
  },
  created() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = null
  },
  async beforeMount() {
    await Promise.all([this.getList('campaign'), this.getList('project')])
  },
  methods: {
    ...mapActions(['getList', 'store']),
    addTag(tag) {
      this.$emit('addTag', tag)
    },
    createTask() {
      if (this.task_validated) {
        this.processValidatedTask()
      } else {
        this.processNoValidatedTask()
      }
    },
    processValidatedTask() {
      this.taskButtonLoading = true
      this.task.team_id = this.team_session
      let query = this.defineQuery()
      console.log(this.task)
      this.store([this.task, query])
        .then((item) => {
          this.$emit('taskCreated')
          window.location.reload()
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          this.taskButtonLoading = false
        })
    },
    processNoValidatedTask() {
      this.task_validated = !this.task_validated
      this.taskButtonLoading = true
      setTimeout(() => {
        this.taskButtonLoading = false
      }, 10000)
      let interval = setInterval((interval) => {
        this.addSeconds(interval)
      }, 1000)

      this.task_loading = 11
    },
    addSeconds(interval) {
      if (this.task_loading > 0) {
        this.task_loading = this.task_loading - 1
      } else {
        clearInterval(interval)
      }
    },
  },
  computed: {
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => {
        return campaign.project_id == this.task.project_id
      })
    },
    filteredProjects() {
      return this.projects.filter((project) => {
        var account = project.account_id == localStorage.session_account
        if (this.team_session == 1) {
          return project.hours > 0 && account
        } else {
          return account
        }
      })
    },
    ...mapGetters({
      projects: 'getProjects',
      campaigns: 'getCampaigns',
    }),
  },
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-special {
  overflow: auto;

  background-image: initial;
  background-color: initial;

  margin-top: initial;
  margin-left: initial;
  background: none;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;

  visibility: visible;

  padding-top: 4rem;
}

.modal-special .modal__content {
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// CreateTaskModal.vue?0b3ec4b1